import { render, staticRenderFns } from "./image-review-dialog.vue?vue&type=template&id=7ad06ff8&scoped=true&"
import script from "./image-review-dialog.vue?vue&type=script&lang=js&"
export * from "./image-review-dialog.vue?vue&type=script&lang=js&"
import style0 from "./image-review-dialog.vue?vue&type=style&index=0&id=7ad06ff8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad06ff8",
  null
  
)

export default component.exports